<template>
    <div
        v-if="bounded && snackbar"
        class="inspection-workspace-status"
        tabindex="0"
        role="status"
        aria-live="polite"
    >
        <span>{{ snackbarMsg }}</span>
        <button
            type="button"
            title="Dismiss inspection status"
            @click="snackbar = false"
        >
            Close
        </button>
    </div>
    <v-snackbar
        v-else-if="!bounded"
        :top="mdAndUp"
        :right="mdAndUp"
        :bottom="smAndDown"
        v-model="snackbar"
        :timeout="3000"
    >
        {{ snackbarMsg }}
        <v-btn color="primary" text @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
</template>

<script>
import { useDisplay } from 'vuetify';

export default {
    name: 'GenericSnackBar',
    props: { bounded: { type: Boolean, default: false } },
    setup() {
        const { mdAndUp, smAndDown } = useDisplay();
        return { mdAndUp, smAndDown };
    },
    data: function () {
        return {
            snackbar: false,
            snackbarMsg: '',
            statusTimer: null,
        };
    },
    beforeUnmount() {
        clearTimeout(this.statusTimer);
    },
    methods: {
        show(msg) {
            this.snackbar = true;
            this.snackbarMsg = msg;
            if (this.bounded) {
                clearTimeout(this.statusTimer);
                this.statusTimer = setTimeout(() => {
                    this.snackbar = false;
                }, 3000);
            }
        },
    },
};
</script>

<style scoped></style>
